import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { Popover } from "@portal/BaseComponents/PopOver/AntPopOver";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";

import { CellRenderProps } from "@sinecycle/growcomponents";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { InvoicesText } from "./InvoicesText";

export interface InvoicesColumns {
  id: string;
  title: string;
  amount: number;
  currency?: string;
}
export interface InvoicesColumnProps<T>
  extends CellRenderProps<T, Array<InvoicesColumns>> {
  title?: string;
  style?: React.CSSProperties;
  onClick?: (id: string) => void;
}
const textStyles: React.CSSProperties = {
  color: "var(--primary-7)",
};
const StyledText = styled(TypographyText)`
  &.more-invoices::after {
    content: ",";
  }
`;
const t = {
  title: "Associated Invoices",
};

function InvoicesColumn<T>(props: InvoicesColumnProps<T>) {
  const { value, title = t.title, onClick } = props;
  const invoices = value;
  const [, setSearchParams] = useSearchParams();
  if (!invoices) return null;
  if (!invoices.length) return <TypographyText>{"-"}</TypographyText>;
  const [first, ...Rest] = invoices;
  const restTypes = Rest.length;

  const mapInvoicePredicate = (invoice: InvoicesColumns) => {
    return (
      <InvoicesText invoice={invoice} key={invoice.id} onClick={onClick} />
    );
  };
  const popOverContent = (
    <Flex vertical align="center">
      <TypographyText fs="12">{title}</TypographyText>
      {invoices.map(mapInvoicePredicate)}
    </Flex>
  );

  const FirstInvoice = (
    <StyledText
      fs="14"
      ellipsis
      // className={second ? "more-invoices" : ""}
      style={{
        ...textStyles,
        maxWidth: "120px",
        cursor: "pointer",
      }}
      onClick={() => {
        onClick?.(first.id);
        setSearchParams({ invoice_id: first.id });
      }}
    >
      {first.title}
    </StyledText>
  );

  // const SecondInvoice = second ? (
  //   <TypographyText
  //     fs="14"
  //     ellipsis={
  //       restTypes > 0 ? true : { tooltip: first.title, onEllipsis(ellipsis) {} }
  //     }
  //     style={{
  //       ...textStyles,
  //       maxWidth: second ? "60px" : "120px",
  //       cursor: "pointer",
  //     }}
  //     onClick={() => {
  //       setSearchParams({ invoice_id: second.id });
  //     }}
  //   >
  //     {second.title}
  //   </TypographyText>
  // ) : null;

  const RestTypes = restTypes ? (
    <TypographyText
      style={{ color: "var(--primary-7)", cursor: "pointer" }}
    >{` + ${restTypes} more`}</TypographyText>
  ) : null;

  return (
    <Popover
      arrow={false}
      content={popOverContent}
      placement="bottom"
      open={restTypes > 0 ? undefined : false}
    >
      <span>
        <span style={{ display: "flex", width: "fit-content" }}>
          {FirstInvoice}
          &nbsp;
          {RestTypes}
        </span>
      </span>
    </Popover>
  );
}

export { InvoicesColumn };
